import styled from '@emotion/styled';
import { Color, mediaQueries } from 'styles/variables';

export const nthList = () => {
    return [1, 2, 3, 4, 5].map(
        i => `&:nth-of-type(${i}) {
                :before {
                    content: '${i}';
                }
            }`,
    );
};

export const ChecklistWrapper = styled.div`
    display: flex;
    flex-direction: column;
    background-color: ${Color.dusk05};
    padding: 2.5rem;

    .content {
        margin-top: 0.8rem;

        li {
            display: flex;
            list-style: none;
            margin: 1.6rem 0;
            color: ${Color.thunder};
            :before {
                display: flex;
                flex-shrink: 0;
                justify-content: center;
                width: 2.4rem;
                height: 2.4rem;
                line-height: 2.4rem;
                margin-right: 0.8rem;
                color: #eadef2;
                background-color: ${Color.dusk100};
                border-radius: 50%;
            }

            ${nthList()}
        }
    }
`;
export const ForDesktop = styled.div`
    display: none;

    ${mediaQueries.largeUp} {
        display: block;
        max-width: 27.7rem;
    }
`;

export const ToggleHeading = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;

    svg {
        fill: ${Color.dusk100};
    }

    h2 {
        margin-bottom: 0;
    }
`;

export const ForMobile = styled.div`
    ${mediaQueries.largeUp} {
        display: none;
    }
`;
